import { ActionTree } from 'vuex';
import { AxiosResponse } from 'axios';
import HttpService from '@/plugins/http-service';
import IRootState from '@/store/types/IRootState';
import IAboutState from './types/IAboutState';
import IAboutMeta from './types/IAboutMeta';
import IAboutHeader from './types/IAboutHeader';
import { IAboutSection } from './types/IAboutSection';

const actions: ActionTree<IAboutState, IRootState> = {
  async load(context) {
    try {
      const { data: {
        meta,
        header,
        sections,
      } }: AxiosResponse<{
        meta: IAboutMeta,
        header: IAboutHeader,
        sections: IAboutSection[],
      }> = await HttpService.get('/page/about.json');

      context.commit('setMeta', meta);
      context.commit('setHeader', header);
      context.commit('setSections', sections);

      return { meta, header, sections };
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export default actions;
